// extracted by mini-css-extract-plugin
export var answer = "bK_g0";
export var arrow = "bK_9";
export var body = "bK_g";
export var category = "bK_cZ";
export var contactIcons = "bK_gT";
export var current = "bK_ft";
export var fade = "bK_gX";
export var footer = "bK_cS";
export var footerText = "bK_cT";
export var icon = "bK_bw";
export var iconContainer = "bK_bX";
export var issue = "bK_gZ";
export var issueContainer = "bK_gW";
export var issueText = "bK_gY";
export var issues = "bK_gV";
export var left = "bK_bL";
export var padding = "bK_dN";
export var right = "bK_bQ";
export var section = "bK_j";
export var selectors = "bK_dW";
export var subtitle = "bK_cq";
export var title = "bK_d";